import { Box, Button, Paper, Stack, Typography, IconButton, Tooltip, Skeleton, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { getToolInfo, getToolInfoSession } from "../../services/tool.service";
// import AdSpace from "../../components/adSpace/AdSpace";
import ToolFormModal from "../../components/toolFormModal/ToolFormModal";
// import ToolTable2 from "../../components/toolTable/ToolTable2";
// import UserMessages from "../../components/userMessages/UserMessages";
// import { setTool, toolSelector } from "../../features/tool/toolSlice";
import { tools } from "../../tools/tools";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../store/system.store";
import { auth } from "../../config/firebase";
import useScreen from "../../components/common/UseScreen";
import { StoreState } from "../../store/store";
import "./track-master.scss";
import TrackMasterLiveTable from "../../components/trackmasterLiveTable/TrackMasterLiveTable2";
import { axiosService } from "../../services/axios.service";
import { ContentCopy, Refresh } from "@mui/icons-material";
import { CacheManager } from "../../utils/cache.utils";

const TrackMaster = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [toolInfo, setToolInfo] = useState<any>({});
  const [page, setPage] = useState(location.pathname.substring(6));
  const tool = tools[0];
  const [sessionInfo, setSessionInfo] = useState(null);
  const user = useSelector((store: StoreState) => store.user.loggedInUser);
  const { isMobile } = useScreen();
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [hasUserPaid, setHasUserPaid] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  // const handleAddRequest = () => {
  //   // setShow(true);
  //   navigate("/product/track-master");
  // };

  const handlePay = () => {
    navigate(`/payment/${toolInfo?.id}`);
  };

  const handleGetToolInfoForUser = async (skipToolInfoFetch = false, page = currentPage, limit = itemsPerPage, forceRefresh = false) => {
    setIsloading(true);
    try {
      if (tool && auth.currentUser) {
        let currentReq = toolInfo;

        if (!skipToolInfoFetch) {
          const response: any = await axiosService.post(`/payment/check-user-paid-for-product`, { userId: auth.currentUser.uid, product: tool.id });
          setHasUserPaid(response?.hasPaid);

          const data = await getToolInfo(tool.id);

          if (data && data.length > 0) {
            setToolInfo(data[0]);
            currentReq = data[0];
          } else {
            setToolInfo([]);
            setIsloading(false);
            navigate("/product/track-master");
            return;
          }
        }

        if (currentReq?.id && currentReq?.productRequestType) {
          const cacheKey = `trackmaster_${currentReq.id}_p${page}_l${limit}`;

          // Try to get cached data first (unless forced refresh)
          if (!forceRefresh) {
            const cachedData = CacheManager.get<any>(cacheKey);
            if (cachedData) {
              // Use cached data
              setSessionInfo(cachedData);
              if (cachedData?.totalPages) setTotalPages(cachedData.totalPages);
              if (cachedData?.totalItems) setTotalItems(cachedData.totalItems);
              setIsloading(false);

              // Fetch new data in background to check for changes
              getToolInfoSession(
                currentReq.productRequestType.toLocaleLowerCase().replace(" ", "-"),
                currentReq.id,
                page,
                limit
              ).then((session) => {
                // Check if data has changed
                if (CacheManager.hasDataChanged(cacheKey, session)) {
                  // Update with new data
                  setSessionInfo(session);
                  if (session?.totalPages) setTotalPages(session.totalPages);
                  if (session?.totalItems) setTotalItems(session.totalItems);
                  CacheManager.set(cacheKey, session);

                  // Notify user of update
                  dispatch(showSnackbar({ msg: "Table data updated", isError: false }));
                }
              }).catch((error) => {
                console.error("Background fetch error:", error);
              });

              return;
            }
          }

          // Fetch fresh data
          const session = await getToolInfoSession(
            currentReq.productRequestType.toLocaleLowerCase().replace(" ", "-"),
            currentReq.id,
            page,
            limit
          );

          // Cache the new data
          CacheManager.set(cacheKey, session);

          // Handle paginated response
          setSessionInfo(session);
          if (session?.totalPages) setTotalPages(session.totalPages);
          if (session?.totalItems) setTotalItems(session.totalItems);
        }

        setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
      console.error(error);
      dispatch(showSnackbar({ msg: "Something went wrong.", isError: true }));
    }
  };

  useEffect(() => {
    setPage(location.pathname.substring(6));
  }, [location]);

  useEffect(() => {
    // const toolToAdd = tools.filter((toolElm) => {
    //   return toolElm.id == page;
    // });
    // dispatch(setTool(toolToAdd[0]));
  }, [page]);

  useEffect(() => {
    if (auth.currentUser) {
      // handleGetData();
      handleGetToolInfoForUser();
    }
  }, [user, tool]);

  useEffect(() => {
    return () => {
      setToolInfo([]);
    };
  }, []);

  const handleCopyLink = (link: string) => {
    navigator.clipboard.writeText(link).then(() => {
      dispatch(showSnackbar({ msg: "Link copied to clipboard!", isError: false }));
    });
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    handleGetToolInfoForUser(true, newPage, itemsPerPage);
  };

  const handleItemsPerPageChange = (newLimit: number) => {
    setItemsPerPage(newLimit);
    setCurrentPage(1);
    handleGetToolInfoForUser(true, 1, newLimit);
  };

  const handleRefresh = () => {
    // Clear cache and force refresh
    CacheManager.clearAll('trackmaster_');
    handleGetToolInfoForUser(false, currentPage, itemsPerPage, true);
  };

  return (
    <Stack gap={3} sx={{ padding: isMobile ? "10px" : "24px" }}>
      {/* <UserMessages /> */}

      <Paper
        sx={{
          backgroundColor: "#02346b",
          boxShadow: "none",
          padding: "24px",
          marginTop: isMobile ? 0 : "24px",
          borderRadius: "8px",
        }}
      >
        <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography fontSize={"20px"} fontWeight={"500"} sx={{ color: "#fff" }}>
              {tool?.header}
            </Typography>
            <Tooltip title="Refresh data">
              <IconButton
                onClick={handleRefresh}
                disabled={isLoading}
                sx={{ color: "#fff" }}
                size="small"
              >
                <Refresh />
              </IconButton>
            </Tooltip>
          </Stack>

          <Typography fontSize={"14px"} sx={{ color: "white" }}>
            {tool?.shortExplanation}
          </Typography>
          {toolInfo?.link && (
            <Stack
              direction={isMobile ? "column" : "row"}
              flexWrap={"wrap"}
              alignItems={isMobile ? "flex-start" : "center"}
              justifyContent={"space-between"}
              gap={2}
              sx={{ marginTop: "12px" }}
            >
              <Box
                onClick={() => handleCopyLink(toolInfo?.link)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "fit-content",
                  border: "1px solid #fff",
                  borderRadius: "111px",
                  cursor: "pointer",
                  paddingInline: "12px",
                  boxSizing: "border-box",
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Tooltip title={toolInfo?.link} arrow>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#fff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {toolInfo?.link}
                    </Typography>
                  </Tooltip>
                </Box>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyLink(toolInfo?.link);
                  }}
                  sx={{ color: "#fff", ml: 1, flexShrink: 0 }}
                >
                  <ContentCopy fontSize="small" />
                </IconButton>
              </Box>
              <Typography
                sx={{
                  border: "1px solid white",
                  borderRadius: "111px",
                  paddingInline: "12px",
                  paddingBlock: "5px",
                }}
                fontSize={"14px"}
                color="white"
              >
                Total clicks: {toolInfo?.data?.length}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Paper>
      {toolInfo?.leftToPay && (
        <Box
          sx={{
            alignItems: "center",

            padding: "24px",
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Stack flexDirection={"row"} gap={"12px"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography fontSize={"20px"}>Left to pay:</Typography>
            <Typography
              fontSize={"14px"}
              sx={{
                border: "1px solid #01346B",
                borderRadius: "111px",
                display: "flex",
                alignItems: "center",
                paddingInline: "12px",
                paddingBlock: "5px",
              }}
            >
              Amount: {toolInfo.leftToPay}450$
            </Typography>
          </Stack>
          <Button
            onClick={handlePay}
            variant="contained"
            sx={{
              color: "white",
              background: "#1A73E8",
              width: "100%",
              paddingBlock: "5px",
            }}
          >
            Pay now
          </Button>
        </Box>
      )}
      <Stack sx={{ minHeight: "50vh", overflowY: "auto" }} direction={"row"} gap={3}>
        {isLoading ? (
          <Paper sx={{ flex: 4, padding: "24px", width: "100%" }}>
            <Stack spacing={3}>
              {/* Header skeleton */}
              <Skeleton variant="text" width="100%" height={32} />

              {/* Table header skeleton */}
              <Stack spacing={2}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="rectangular" width="20%" height={36} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width="15%" height={36} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width="12%" height={36} sx={{ borderRadius: 1 }} />
                </Stack>

                {/* Table rows skeleton */}
                {Array.from({ length: 8 }).map((_, index) => (
                  <Stack key={index} direction="row" spacing={2} alignItems="center" sx={{ py: 1, width: "100%" }}>
                    <Skeleton variant="text" width="25%" />
                    <Skeleton variant="text" width="20%" />
                    <Skeleton variant="text" width="15%" />
                    <Skeleton variant="text" width="20%" />
                    <Skeleton variant="rectangular" width="10%" height={24} sx={{ borderRadius: "12px" }} />
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Paper>
        ) : (
          <>
            <Paper sx={{ flex: 4, padding: "24px", width: "fit-content" }}>
              {/* <ToolTable2
            setShow={setShow}
            header={tool && tool?.header ? `${tool?.header}'s Requests` : ""}
            isLoading={isLoading}
            resetTools={handleGetToolInfoForUser}
            toolInfo={toolInfo}
          /> */}

              <TrackMasterLiveTable sessionInfo={sessionInfo} hasPaid={hasUserPaid} />

              {/* Pagination Controls */}
              { sessionInfo && totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3, flexWrap: 'wrap', gap: 2 }}>
                  <Stack direction="row" alignItems="center" gap={2}>
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <InputLabel>Items per page</InputLabel>
                      <Select
                        value={itemsPerPage}
                        label="Items per page"
                        onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                      >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                      </Select>
                    </FormControl>
                    <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                      Showing {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} items
                    </Typography>
                  </Stack>

                  <Stack direction="row" alignItems="center" gap={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(1)}
                    >
                      First
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </Button>

                    <Typography variant="body2" sx={{ mx: 2, whiteSpace: 'nowrap' }}>
                      Page {currentPage} of {totalPages}
                    </Typography>

                    <Button
                      variant="outlined"
                      size="small"
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(totalPages)}
                    >
                      Last
                    </Button>
                  </Stack>
                </Box>
              )}
            </Paper>
          </>
        )}
        {/* {!isMobile ? <AdSpace flex={2} /> : null} */}
      </Stack>
      <Box tabIndex={-1}>
        <ToolFormModal show={show} setShow={setShow} tool={tool} />
      </Box>

      {/* {isMobile ? <AdSpace /> : null} */}
    </Stack>
  );
};

export default TrackMaster;
